var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar',{staticClass:"nav-bar",staticStyle:{"z-index":"10","display":""}}),_c('app-main',{staticClass:"app-main"}),_c('app-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }